
require('../../../sass/components/CustomerBox/_cart.scss');

export const Cart = {
    name: 'Cart',
    data: function () {
        return {}
    },
    props: {
        _class: String,
        _count: 0,
        _url: {
            type: String,
            default: '/'
        }
    },
    template: `
      <div>
              <a :class="_class" :href="_url">
              <span>{{ _count }}</span>
              </a>
      </div>
    `
};